import { GSEName } from '../loan/Loan';
import { RecurringCompanyReport } from '../RecurringCompanyReport';
import { Timezone } from '../Time';
import { FANNIE_MAE_DEFAULT_RECURRING_REPORT_VALUES, FANNIE_MAE_TIMEZONE } from './FannieMae/FannieMae.constants';
import { FHA_DEFAULT_RECURRING_REPORT_VALUES, FHA_TIMEZONE } from './FHA/FHA.constants';
import { FREDDIE_MAC_DEFAULT_RECURRING_REPORT_VALUES, FREDDIE_MAC_TIMEZONE } from './FreddieMac/FreddieMac.constants';
import { GINNIE_MAE_DEFAULT_RECURRING_REPORT_VALUES, GINNIE_MAE_TIMEZONE } from './GinnieMae/GinnieMae.constants';
import { InvestorReportingReportType } from './InvestorReporting';
import { MI_DEFAULT_RECURRING_REPORT_VALUES, MI_TIMEZONE } from './MI/MI.constants';

export { FHA_TIMEZONE, FHA_HOLIDAYS } from './FHA/FHA.constants';
export { FANNIE_MAE_TIMEZONE, FANNIE_MAE_HOLIDAYS } from './FannieMae/FannieMae.constants';
export { GINNIE_MAE_TIMEZONE, GINNIE_MAE_HOLIDAYS } from './GinnieMae/GinnieMae.constants';
export { FREDDIE_MAC_TIMEZONE, FREDDIE_MAC_HOLIDAYS } from './FreddieMac/FreddieMac.constants';
export { MI_TIMEZONE } from './MI/MI.constants';

export const INVESTOR_REPORT_DEFAULT_RECURRING_REPORT_VALUES: Record<
  InvestorReportingReportType,
  Pick<RecurringCompanyReport, 'deliveryHour' | 'deliveryTimeZone' | 'title'> & { deliveryDay: number }
> = {
  ...FANNIE_MAE_DEFAULT_RECURRING_REPORT_VALUES,
  ...FREDDIE_MAC_DEFAULT_RECURRING_REPORT_VALUES,
  ...GINNIE_MAE_DEFAULT_RECURRING_REPORT_VALUES,
  ...FHA_DEFAULT_RECURRING_REPORT_VALUES,
  ...MI_DEFAULT_RECURRING_REPORT_VALUES,
};

export const INVESTOR_TO_TIMEZONE: Record<GSEName, Timezone> = {
  FNMA: FANNIE_MAE_TIMEZONE,
  FHLMC: FREDDIE_MAC_TIMEZONE,
  GNMA: GINNIE_MAE_TIMEZONE,
  FHA: FHA_TIMEZONE,
  MI: MI_TIMEZONE,
};
